module.exports = __webpack_public_path__ + "static/media/logo-windows.45fff7fb.svg";